<template>
  <div id="product" class="c-content">
    <banner-child :content="banner"></banner-child>

    <div class="c-standard">
      <product-image-block v-for="(item, index) in productItem" :key="index" :content="item"></product-image-block>
    </div>
    
    <div class="c-standard" style="padding-top: 0">
      <div class="c-productText__imgs" style="padding-top: 0">
        <div class="c-productText__img" v-for="(x, y) in productImage.imgs" :key="y" :style="{backgroundImage:'url('+ x.img +')'}">
        </div>
      </div>
    </div>

    <div class="c-standard" style="padding-top: 0">
      <product-page-route :index="index"></product-page-route>
    </div>
  </div>
</template>

<script>
  import BannerChild from '../layout/bannerChild.vue'
  import ProductImageBlock from '../layout/productImageBlock.vue'
  import ProductPageRoute from '../layout/productPageRoute.vue'

  export default {
    name: 'product_5',
    components: {
      'banner-child': BannerChild,
      'product-page-route': ProductPageRoute,
      'product-image-block': ProductImageBlock,
    },
    data(){
      return {
        text: {
          more: this.$t('common.more')
        },
        banner: {
          img: require('../../assets/img/product/product_banner_05.jpg'),
          title: this.$t('product_5.banner.title'),
          content: this.$t('product_5.banner.content'),
        },
        index: 4,
        productItem:[
          {
            bgColor: '',
            className: 'flexRow',
            image: require('../../assets/img/product_pressalit_bathe_a.jpg'),
            content: [
              {type: 'title', content: this.$t('product_5.content.items.item1.title')},
              {type: 'text', content: this.$t('product_5.content.items.item1.text')},
            ]
          },
          {
            bgColor: '',
            className: 'flexRowReverse',
            image: require('../../assets/img/product_pressalit_bathe_b.jpg'),
            content: [
              {type: 'title', content: this.$t('product_5.content.items.item2.title')},
              {type: 'text', content: this.$t('product_5.content.items.item2.text')},
            ]
          },
        ],
        productImage: {
          imgs:[
            {img: require('../../assets/img/product/product_pressalit_bathe02.jpg')},
            {img: require('../../assets/img/product/product_pressalit_bathe03.jpg')},
            {img: require('../../assets/img/product/product_pressalit_bathe04.jpg')},
          ]
        }
      }
    },
    computed: {

    },
    created () {

    },
    methods: {

    },
  }
</script>

<style>

</style>
